/**
 * undefinedか否か
 * @param val {*}
 * @return {Boolean}
 * *
 */
export const isUndefined = (val) => typeof val === 'undefined';
